/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { ownerDraftsControllerOwner } from "./ownerDraftsControllerOwner";
import { ownerDraftsControllerStartOwner } from "./ownerDraftsControllerStartOwner";

export function ownerDraftsService() {
  return { ownerDraftsControllerOwner, ownerDraftsControllerStartOwner }
}